__turbopack_context__.v({
  "error": "radio-module-scss-module__lQyTra__error",
  "footer": "radio-module-scss-module__lQyTra__footer",
  "placeholder": "radio-module-scss-module__lQyTra__placeholder",
  "wrapper": "radio-module-scss-module__lQyTra__wrapper",
});
